import { PendoAttributes } from 'src/components/PendoTracker/types';
import { IUserMetricsService } from './user-metrics-service.interface';

export class GuestPendoMetricsService implements IUserMetricsService<PendoAttributes> {
  async fetchTrackedAttributes(): Promise<PendoAttributes> {
    const visitor: PendoAttributes['visitor'] = {
      type: 'Guest',
      url: window.location.href
    };

    const account: PendoAttributes['account'] = {
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
    };

    return {
      visitor,
      account
    };
  }
}
